import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

type Color = 'yellow' | 'blue' | 'green';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-progress-bar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ds-progress-bar.component.html',
    styleUrls: ['./ds-progress-bar.component.scss'],
    standalone: false
})
export class DsProgressBarComponent {

  @Input() progressPercent: number;
  @Input() title?: string;
  @Input() label?: string;
  @Input() color?: Color = 'yellow';

}
